export default __webpack_public_path__ + "static/media/A9204491_tn.729f6991.jpg";